module.exports = {"fr-FR":{"map":{"cooperatives_list":"Liste d'associations"}}}